import React, { useState } from 'react'
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { Modal } from 'antd';
import { Table, Tag, Space } from 'antd';
import { DatePicker, TimePicker } from 'antd'
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
const { RangePicker } = DatePicker;


const PaymentInvoiceProcessSOM = () => {
    const title = "Payment Invoice Process SOM";
    const navigate = useNavigate();
    const [IsRemarksModalOpen, setIsRemarksModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false)

    const _doNavToPaymentApprove = () => {
        navigate("/PaymentProcessApproveReject");
    }
    const _docheckstatus = () => {
        _doNavToPaymentApprove()
    }
    const _doOpenRemarksModal = () => {
        setIsModalOpen(true);
        setIsRemarksModalOpen(true)
    }
    const _doCloseRemarksModal = () => {
        setIsModalOpen(false);
        setIsRemarksModalOpen(false)
    }

    const _doSelectVender = () => {

    }

    const TableData = [
        {
            key: '1',
            VendorName: "ELECTRICAL",
            ContractName: "TRANSFORMER",
            InvoiceNumber: "IN12344 ",
            InvoiceDate: "05-08-2021",
            CreatedDate: "05-12-2021",
            Amount: "10000",
            GST: "10",
            GSTAmount: "100",
            TotalAmount: "10100",
            Status: "Pending",
            Remarks: "Remarks"
        },
        {
            key: '2',
            VendorName: "ELECTRICAL",
            ContractName: "TRANSFORMER",
            InvoiceNumber: "IN12344 ",
            InvoiceDate: "05-08-2021",
            CreatedDate: "05-12-2021",
            Amount: "10000",
            GST: "10",
            GSTAmount: "100",
            TotalAmount: "10100",
            Status: "Accepted",
            Remarks: "Remarks"
        },
        {
            key: '3',
            VendorName: "ELECTRICAL",
            ContractName: "TRANSFORMER",
            InvoiceNumber: "IN12344 ",
            InvoiceDate: "05-08-2021",
            CreatedDate: "05-12-2021",
            Amount: "10000",
            GST: "10",
            GSTAmount: "100",
            TotalAmount: "10100",
            Status: "Rejected",
            Remarks: "Remarks"
        },
        {
            key: '4',
            VendorName: "ELECTRICAL",
            ContractName: "TRANSFORMER",
            InvoiceNumber: "IN12344 ",
            InvoiceDate: "05-08-2021",
            CreatedDate: "05-12-2021",
            Amount: "10000",
            GST: "10",
            GSTAmount: "100",
            TotalAmount: "10100",
            Status: "Payment Processed",
            Remarks: "Remarks"
        }

    ]
    const TableColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <Space size="middle">
                    <div className="table-icons">
                        <i className="fa fa-eye orange" onClick={_docheckstatus} ></i>
                        <i className="fa fa-pencil blue" onClick={_docheckstatus} ></i>
                    </div>
                </Space>
            ),
        },
        {
            title: "Vendor Name",
            dataIndex: "VendorName",
            key: "VendorName"
        },
        {
            title: "Contract Name",
            dataIndex: "ContractName",
            key: "ContractName"
        },
        {
            title: "Invoice Number",
            dataIndex: "InvoiceNumber",
            key: "InvoiceNumber"
        },
        {
            title: "Invoice Date",
            dataIndex: "InvoiceDate",
            key: "InvoiceDate"
        },
        {
            title: "Created Date",
            dataIndex: "CreatedDate",
            key: "CreatedDate"
        },
        {
            title: "Amount",
            dataIndex: "Amount",
            key: "Amount"
        },
        {
            title: "GST",
            dataIndex: "GST",
            key: "GST"
        },
        {
            title: "GST Amount",
            dataIndex: "GSTAmount",
            key: "GSTAmount"
        },
        {
            title: "Total Amount",
            dataIndex: "TotalAmount",
            key: "TotalAmount"
        },
        {
            title: "Status",
            dataIndex: "Status",
            key: "Status"
        },
        {
            title: "Remarks",
            dataIndex: "Remarks",
            key: "Remarks",
            render: (text, record) => (
                <Space size="middle">
                    <div className="table-icons">
                        <i onClick={_doOpenRemarksModal} className="fa fa-eye blue"></i>
                    </div>
                </Space>
            ),
        }

    ]
    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            {
                IsRemarksModalOpen == true ?
                    <Modal
                    open={isModalOpen} title="Remarks"

                        footer={[
                            <button type='button' onClick={_doCloseRemarksModal} className='btn muted-button  deca-btn-orange'>Close</button>
                        ]}
                    >
                        <div className="">
                            <ul className="remarks__list">
                                <li className="remarks__item">
                                    <div className="remarks__userdetails">
                                        <h5>Karthik</h5>
                                        <h5>On 12 Aug 2021 10:45 AM</h5>
                                    </div>
                                    <div className="remarks__reason">
                                        <p>Change date and time</p>
                                    </div>
                                </li>
                                <li className="remarks__item">
                                    <div className="remarks__userdetails">
                                        <h5>Karthik</h5>
                                        <h5>On 12 Aug 2021 10:45 AM</h5>
                                    </div>
                                    <div className="remarks__reason">
                                        <p>Change date and time</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Modal> : null
            }
            <div className='content-wrapper'>
                <section className='content top-space'>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>Vendor*</label>
                                        <Select className="form-control"
                                            showSearch
                                            onChange={_doSelectVender}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            <Option value="1">Vendor 1</Option>
                                            <Option value="2">Vendor 2</Option>
                                            <Option value="3">Vendor 3</Option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>Status*</label>
                                        <Select className="form-control"
                                            showSearch
                                            onChange={_doSelectVender}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            <Option value="1">Pending </Option>
                                            <Option value="2">Accepted </Option>
                                            <Option value="3">Rejected </Option>
                                            <Option value="4">Payment Processed </Option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3 btn-no-lbl">
                                    <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'>
                                        <i className="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="m-table__main">
                                <div className="m-table__responsive medium-width">
                                    <Table scroll={{Y:300}} pagination={false} columns={TableColumns} dataSource={TableData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default PaymentInvoiceProcessSOM
